import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TBillingFinalizedQuote } from './types';

export function useBillingQuoteFinalized(quoteId: string | null) {
  const { data, error, isLoading, mutate } =
    useSWR<TBillingFinalizedQuote | null>(
      quoteId ? `commenda-billing/quotes/${quoteId}/finalized` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { finalized: data ?? null, error, isLoading, mutate };
}
